module.exports = __webpack_public_path__ + "static/img/banner3.932b490.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/picture/banner/banner3.jpg
// module id = w9HF
// module chunks = 0